import ResourceList from "@/components/ResourceList";
import { Stethoscope } from "@phosphor-icons/react";

export default function Doctors() {
  return (
    <ResourceList
      title="Doctors"
      subtitle="Care team"
      resource="doctors"
      icon={Stethoscope}
      testidPrefix="doctors"
      emptyText="No doctors added yet"
      itemTitle={(d) => d.name}
      itemSubtitle={(d) => [d.specialty, d.phone].filter(Boolean).join(" · ")}
      itemBadge={(d) => d.notes ? <div className="mt-2 text-sm text-[#576A62] line-clamp-2">{d.notes}</div> : null}
      fields={[
        { key: "name", label: "Doctor name", required: true, placeholder: "Dr. Alice Nguyen" },
        { key: "specialty", label: "Specialty", placeholder: "Cardiologist" },
        { key: "phone", label: "Phone", placeholder: "+1 555-000-1212" },
        { key: "email", label: "Email", type: "email" },
        { key: "practice", label: "Practice / hospital" },
        { key: "address", label: "Address" },
        { key: "notes", label: "Notes", textarea: true },
      ]}
    />
  );
}
